import '../scss/app.scss';
import lozad from "lozad";
import {initLanding} from "./components/loans";
import Cookies from 'js-cookie';
import * as wurl from "vanilla-js-url";


export const TERM_CLASSIFICATOR = {
    1: {
        name: 'сек.',
        Turkey: '',
        Vietnam: '',
    },
    2: {
        name: 'мин.',
        Turkey: '',
        Vietnam: '',
    },
    3: {
        name: 'ч.',
        Turkey: '',
        Vietnam: '',
    },
    4: {
        name: 'дн.',
        Turkey: 'gün',
        Vietnam: 'ngày',
    },
    5: {
        name: 'нд.',
        Turkey: 'hafta',
        Vietnam: 'một tuần',
    },
    6: {
        name: 'м.',
        Turkey: 'ay',
        Vietnam: 'tháng',
    },
    7: {
        name: 'г.',
        Turkey: 'yıl',
        Vietnam: 'năm',
    },
}

export const settings = {
    'Turkey': {
        country_code: 792,
        currency_code: 949,
        currency_name: 'TRY',
        currency_symbol: '₺',
        item_sum_text: 'Tutar',
        item_term_text: 'Süre',
        item_stake_text: 'Faiz oranı',
        item_button_text: 'Parayı al',
        item_from_text: 'ile',
    },
    'Mexico': {
        country_code: 484,
        currency_code: 484,
        currency_name: 'MXN',
        currency_symbol: '$',
        item_sum_text: 'Tutar',
        item_term_text: 'Süre',
        item_stake_text: 'Faiz oranı',
        item_button_text: 'Parayı al',
        item_from_text: 'ile',
    },
    'Malaysia': {
        country_code: 458,
        currency_code: 458,
        currency_name: 'MYR',
        currency_symbol: 'RM',
        item_sum_text: 'Tutar',
        item_term_text: 'Süre',
        item_stake_text: 'Faiz oranı',
        item_button_text: 'Parayı al',
        item_from_text: 'ile',
    },
    'Brazil': {
        country_code: 76,
        currency_code: 986,
        currency_name: 'BRL',
        currency_symbol: 'R$',
        item_sum_text: 'Tutar',
        item_term_text: 'Süre',
        item_stake_text: 'Faiz oranı',
        item_button_text: 'Parayı al',
        item_from_text: 'ile',
    },
    'Philippines': {
        country_code: 608,
        currency_code: 608,
        currency_name: 'PHP',
        currency_symbol: '₱',
        item_sum_text: 'Tutar',
        item_term_text: 'Süre',
        item_stake_text: 'Faiz oranı',
        item_button_text: 'Parayı al',
        item_from_text: 'ile',
    },
    'Vietnam': {
        country_code: 704,
        currency_code: 704,
        currency_name: 'VND',
        currency_symbol: '₫',
        item_sum_text: 'Số tiền vay',
        item_term_text: 'Thời gian vay',
        item_stake_text: 'lãi suất',
        item_button_text: 'Đăng ký vay',
        item_from_text: 'từ',
    },
}

/* Your JS Code goes here */
$(document).ready(function () {
    //Если куки нет проставляем, если есть добавляем через /
    if (wurl.getParams(window.location.href)['source'] && !Cookies.get('source')) {
        Cookies.set('source', `${wurl.getParams(window.location.href)['source']}`)
    } else {
        if (Cookies.get('source') !== wurl.getParams(window.location.href)['source']) {
            if (wurl.getParams(window.location.href)['source']) {
                Cookies.set('source', `${Cookies.get('source')}/${wurl.getParams(window.location.href)['source']}`)
            }
        }
    }

    const observer = lozad('.lozad', {
        load: function (el) {
            if (el.dataset.background) {
                $(el).css('background-image', 'url(' + el.dataset.background + ')');
            }

            if (el.dataset.src) {
                el.src = el.dataset.src
            }

            el.classList.add('fade')
        }
    });

    observer.observe();

    let errorInterval = null;

    try {
        ga(function () {
            initLanding();
        })
    } catch (e) {
        console.warn('ga not loaded!!!')
        errorLoadFunction()
    }


    function errorLoadFunction() {
        errorInterval = setInterval( () => {
            try {
                ga(function () {
                    clearInterval(errorInterval)
                    initLanding();
                })
            } catch (e) {
                console.warn('ga not loaded!!!')
                errorLoadFunction()
            }
        }, 1000)
    }
})
